import { render } from "./AlertOctagon.vue?vue&type=template&id=333a8b56"
import script from "./AlertOctagon.vue?vue&type=script&lang=js"
export * from "./AlertOctagon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__